@if (loading) {
    <div class="page"><app-spinner [fullscreen]="false"></app-spinner></div>
} @else if (error) {
    <app-error-ficha [mensaje]="error" (reintentar)="ngOnInit()" (volver)="volverAlListado()"></app-error-ficha>
} @else {
    @if(mode === 'Crear' || mode === 'Editar') {
        <div class="page page--form">
            <app-formulario
                [title]="titleForm"
                [buttons]="buttons"
                [fields]="fields"
                [type]="type"
                [functionSelected]="functionSelected">
            </app-formulario>
        </div>
    } @else if(mode === 'list') {
        <div class="page">
            <button type="button" class="back-link mb-2" data-testid="volver" (click)="volver()"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver</button>
            <header class="page-header" data-seccion="historico">
                <span class="page-header__icon" aria-hidden="true"><i class="bi bi-archive-fill"></i></span>
                <div class="page-header__text">
                    <h1>Histórico de cargos</h1>
                    <p>{{asociado.nombre}} {{asociado.apellidos}}</p>
                </div>
                <div class="page-header__actions">
                    @if (puedeEscribir) {
                        <button type="button" class="btn btn-primary" data-testid="anadir-relacion" (click)="loadFormConfig('Post')"><i class="bi bi-plus-lg" aria-hidden="true"></i>Añadir relación</button>
                    }
                </div>
            </header>

            @if (editando) {
                <app-historico-editar [relacion]="editando" (guardado)="tras_guardar()" (cancelado)="cerrarEdicion()"></app-historico-editar>
            }
            <div class="toolbar-summary">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="mostrar-todo" data-testid="mostrar-todo" [checked]="mostrarTodo" (change)="alternarMostrarTodo()">
                    <label class="form-check-label" for="mostrar-todo">Mostrar también ejercicios anteriores y bajas</label>
                </div>
                <a class="btn btn-outline-secondary btn-sm" routerLink="/historico" [queryParams]="{ asociado: asociado.id }" data-testid="consulta-completa"><i class="bi bi-funnel" aria-hidden="true"></i>Consulta completa con filtros</a>
            </div>
            @if (errorRelaciones) {
                <div class="state-panel state-panel--error mb-3" role="alert" data-testid="error-relaciones">
                    <i class="bi bi-wifi-off state-panel__icon" aria-hidden="true"></i>
                    <p class="state-panel__text">{{ errorRelaciones }}</p>
                    <button type="button" class="btn btn-outline-danger btn-sm" data-testid="reintentar-relaciones" (click)="cargarRelaciones()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
                </div>
            }
            <section class="panel panel--flush results-area" aria-label="Relaciones de la persona">
                @if (cargandoRelaciones) {
                    <div class="progress results-progress" role="progressbar" aria-label="Cargando" data-testid="cargando-relaciones"><div class="progress-bar progress-bar-striped progress-bar-animated w-100"></div></div>
                }
                <div class="table-wrap" tabindex="0" role="region" aria-label="Tabla de relaciones (desplazable)">
                    <table class="table table-hover align-middle table-stack" data-testid="tabla-relaciones">
                        <thead><tr><th scope="col">Ejercicio</th><th scope="col">Asociación</th><th scope="col">Cargo</th><th scope="col">Tipo</th><th scope="col">Estado</th><th scope="col"><span class="visually-hidden">Acciones</span></th></tr></thead>
                        <tbody>
                            @for (r of relaciones; track r.idAsociacion + '-' + r.idCargo + '-' + r.idEjercicio + '-' + r.idTipoHistorico) {
                                <tr data-testid="fila-relacion">
                                    <td data-label="Ejercicio">{{ r.anyoEjercicio }}@if (r.ejercicioVigente) { <span class="badge text-bg-primary ms-1">vigente</span> }</td>
                                    <td data-label="Asociación">{{ r.nombreAsociacion }}</td>
                                    <td data-label="Cargo">{{ r.cargo }}</td>
                                    <td data-label="Tipo">{{ r.tipo }}</td>
                                    <td data-label="Estado"><span class="badge" [ngClass]="ETIQUETA[r.estado].clase" [title]="ETIQUETA[r.estado].ayuda">{{ ETIQUETA[r.estado].texto }}</span></td>
                                    <td data-label="" class="text-end text-nowrap">
                                        @if (puedeEscribir && (r.estado === 'vigente' || r.estado === 'historico')) {
                                            <button type="button" class="btn btn-outline-secondary btn-sm me-1" data-testid="editar-relacion" (click)="editar(r)"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar</button>
                                        }
                                        @if (puedeEscribir && r.estado === 'vigente') {
                                            <button type="button" class="btn btn-outline-danger btn-sm" data-testid="baja-relacion" (click)="darDeBaja(r)"><i class="bi bi-person-dash" aria-hidden="true"></i>Dar de baja</button>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                @if (!cargandoRelaciones && !errorRelaciones && !relaciones.length) {
                    <p class="empty-inline" data-testid="sin-relaciones">No hay relaciones@if (!mostrarTodo) { vigentes } en el histórico de esta persona.</p>
                }
            </section>
            @if (totalRelaciones > relaciones.length) {
                <p class="small text-muted mt-2" data-testid="aviso-limite">Se muestran las {{ relaciones.length }} más recientes de {{ totalRelaciones }}. Usa la consulta completa para filtrar.</p>
            }
        </div>
    }
}
